<div
  class="journey-application-details container d-flex flex-column align-items-start align-self-stretch"
  [ngClass]="{ 'no-back': !showBackButton }">
  <a
    *ngIf="showBackButton"
    class="back-button text-decoration-none d-flex flex-row align-items-center mb-2"
    (click)="goBack()">
    <i class="icon-chevron-left me-2"></i>
    <span class="d-inline">{{ 'Back to search' | translate }}</span>
  </a>

  <h2 *ngIf="showBackButton" class="mt-4 w-100">
    {{ 'Application found' | translate }}
  </h2>

  <div class="card mb-4 w-100">
    <div class="card-body top">
      <div class="application-header row">
        <div class="status-badge col-12 col-md-8" *ngIf="application">
          <h3 class="mt-2">{{ application.serviceName || '' | translate }}</h3>
          <p>
            {{ 'Application No' | translate }}:
            {{ application.applicationNumber }}
          </p>
        </div>
        <div
          *ngIf="
            isJourney() === false ||
            application?.applicationType === 'JOURNEY_V3'
          "
          class="col-12 col-md-4 d-flex justify-content-end">
          <!-- Application Actions Section -->
          <div class="app-actions-section mt-2 mt-md-0">
            <!-- Completed Applications -->
            <div
              *ngIf="application.applicationStatus !== 'PAYMENT_PENDING'"
              class="action-buttons"
              [class.single-button]="
                !(
                  applicationDetails &&
                  applicationDetails['paymentStatus'] === 'PAID' &&
                  !isSelectedApplicationFree(application)
                ) ||
                !(
                  applicationDetails &&
                  applicationDetails['officerAttachments'] &&
                  applicationCertificates(applicationDetails).length > 0
                )
              ">
              <!-- Certificate Dropdown (shown for Journey V3) -->
              <div
                *ngIf="getUnifiedCertificates().length > 0 && viewFullDetails"
                class="dropdown certificate-dropdown">
                <button
                  #certificateDropdown
                  class="btn download-btn dropdown-toggle"
                  type="button"
                  id="certificateDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  [disabled]="downloadingCert"
                  (click)="$event.stopPropagation()">
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    *ngIf="downloadingCert"></span>
                  {{ 'Download Certificate' | translate }}
                </button>
                <ul
                  class="dropdown-menu dropdown-menu-end certificate-menu"
                  aria-labelledby="certificateDropdown">
                  <li class="dropdown-header">
                    {{ 'AVAILABLE CERTIFICATES' | translate }}
                  </li>
                  <hr class="dropdown-divider" />

                  <li *ngFor="let item of getUnifiedCertificates()">
                    <a
                      class="dropdown-item d-flex align-items-center gap-2"
                      [class.disabled]="downloadingCert"
                      [style.cursor]="
                        downloadingCert ? 'not-allowed' : 'pointer'
                      "
                      [style.pointer-events]="downloadingCert ? 'none' : 'auto'"
                      (click)="
                        handleUnifiedDownload(item); $event.stopPropagation()
                      ">
                      <span class="me-2" *ngIf="item.localeFlag">{{
                        item.localeFlag
                      }}</span>
                      <i
                        class="icon-file-02 text-muted me-2"
                        *ngIf="item.isOfficerAttachment"></i>

                      <span class="nativeName text-truncate flex-grow-1">{{
                        item.label | translate
                      }}</span>
                      <i
                        class="fa fa-spinner fa-spin text-muted"
                        *ngIf="downloadingCert"></i>
                      <i
                        class="fa fa-download text-muted"
                        *ngIf="!downloadingCert"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- Receipt Button (hidden for Journey V3 as we are not handling payment yet) -->
              <div
                *ngIf="
                  application &&
                  (application.paymentStatus === null ||
                    application.paymentStatus !== 'PAYMENT_PENDING') &&
                  !isSelectedApplicationFree(application) &&
                  (isLoggedIn || showReceiptDownloadButton) &&
                  application?.applicationType !== 'JOURNEY_V3'
                "
                class="dropdown receipt-dropdown ms-2">
                <button
                  #receiptDropdown
                  class="btn download-btn dropdown-toggle"
                  type="button"
                  id="receiptDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  [disabled]="downloadingReceipt || downloadingReciept"
                  (click)="$event.stopPropagation()">
                  <span *ngIf="!(downloadingReceipt || downloadingReciept)">
                    {{ 'Download Receipt' | translate }}
                  </span>
                  <span *ngIf="downloadingReceipt || downloadingReciept">
                    <i class="fa fa-spinner fa-spin"></i>
                    {{ 'Downloading' | translate }}
                  </span>
                </button>

                <ul
                  class="dropdown-menu dropdown-menu-end certificate-menu"
                  aria-labelledby="receiptDropdown">
                  <li class="dropdown-header">
                    {{ 'AVAILABLE LANGUAGES' | translate }}
                  </li>
                  <hr class="dropdown-divider" />

                  <li *ngFor="let item of receiptSupportedLocales">
                    <a
                      class="dropdown-item d-flex align-items-center gap-2"
                      style="cursor: pointer"
                      (click)="
                        downloadReceipt(
                          application.applicationNumber,
                          item.locale
                        );
                        $event.stopPropagation()
                      ">
                      <span class="nativeName text-truncate flex-grow-1">{{
                        item.nativeName
                      }}</span>
                      <i class="fa fa-download text-muted"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Payment Button (hidden for Journey V3 as we are not handling payment yet) -->
            <div
              *ngIf="
                application.applicationStatus === 'PAYMENT_PENDING' &&
                application?.applicationType !== 'JOURNEY_V3'
              "
              class="payment-button justify-content-md-end">
              <button
                (click)="makePayment(); $event.stopPropagation()"
                class="btn btn-primary pay-now-btn">
                {{ 'Pay now' | translate }}
              </button>
            </div>

            <!-- Edit Button (shown for Journey V3) -->
            <button
              *ngIf="
                (application?.applicationType === 'JOURNEY_V3' ||
                  applicationDetails ||
                  isLegacyApplication) &&
                editApplicationEvent.observed &&
                application?.applicationStatus?.includes(
                  'PENDING_RESUBMISSION'
                ) &&
                showEditApplicationButton
              "
              (click)="editApplication()"
              class="btn btn-primary d-flex flex-row gap-2 align-items-center text-white">
              <i class="icon-edit-05"></i>{{ 'Edit' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="row application-info">
        <div class="col-md-4">
          <p class="text-muted mb-1">{{ 'Status' | translate }}</p>
          <div class="status-badges-container">
            <p
              *ngIf="!application.applicationStatusNames"
              class="w-bold irembo-badge"
              [ngClass]="
                getApplicationStatusToColor(
                  application?.applicationStatus || ''
                )
              ">
              {{
                changeApplicationStatusToLabel(application?.applicationStatus)
                  | translate
              }}
            </p>
            <p
              *ngIf="application.applicationStatusNames"
              class="w-bold irembo-badge"
              [ngClass]="
                getApplicationStatusToColor(
                  application?.applicationStatus || ''
                )
              ">
              {{
                application.applicationStatusNames[getLocale()] ??
                  changeApplicationStatusToLabel(application?.applicationStatus)
                  | translate
              }}
            </p>
            <p
              *ngIf="application?.partnerApplicationStatus"
              class="w-bold irembo-badge partner-status-badge"
              [attr.title]="
                'Partner Status: ' +
                (application?.partnerApplicationStatus | translate)
              ">
              {{ application?.partnerApplicationStatus | translate }}
            </p>
          </div>
        </div>
        <div class="col-md-3">
          <p class="text-muted mb-1">{{ 'Submitted on' | translate }}</p>
          <p class="w-bold">
            {{
              application.dateCreated
                ? (convertDate(application.dateCreated) | date : 'short')
                : '-'
            }}
          </p>
        </div>
        <div class="col-md-3">
          <p class="text-muted mb-1">{{ 'Last Updated' | translate }}</p>
          <p class="w-bold">
            {{
              application.lastUpdated
                ? (convertDate(application.lastUpdated) | date : 'short')
                : '-'
            }}
          </p>
        </div>
        <div class="col-md-2">
          <p class="text-muted mb-1">{{ 'Service fee' | translate }}</p>
          <p class="w-bold">
            {{ application.price === 0 ? '' : application.currency }}
            {{
              application.price === 0 ? 'FREE' : (application.price | number)
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="card-body bottom">
      <div *ngIf="!showFullDetails" class="text-center">
        <div class="col-12">
          <div class="footer">
            <!-- Gov3 View Details Button (with OTP) -->
            <button
              *ngIf="!isLegacyApplication"
              id="viewMoreDetails"
              (click)="handleViewMoreDetails(token)"
              class="btn btn-primary text-center w-100"
              [ngClass]="{
                'visually-hidden': !showBackButton || viewMoreDetails
              }">
              <div
                *ngIf="requestingAccess"
                class="spinner-border spinner-border-sm"
                role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              View application details
            </button>

            <!-- Gov2 View Details Button (with OTP via Hub proxy) -->
            <button
              *ngIf="isLegacyApplication && gov2SummaryId"
              id="viewMoreDetailsGov2"
              (click)="handleGov2ViewMoreDetails(token)"
              class="btn btn-primary text-center w-100"
              [ngClass]="{
                'visually-hidden': viewMoreDetails
              }">
              <div
                *ngIf="requestingAccess || isLoadingGov2Summary"
                class="spinner-border spinner-border-sm"
                role="status">
                <span class="visually-hidden">{{
                  'Loading...' | translate
                }}</span>
              </div>
              {{ 'View application details' | translate }}
            </button>

            <!-- Gov2 No Details Available -->
            <p *ngIf="isLegacyApplication && !gov2SummaryId" class="text-muted">
              {{
                'Detailed application information is not available for this application.'
                  | translate
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="application && viewMoreDetails">
        <div class="col-12">
          <div class="application text-start col-12">
            <div class="row">
              <div class="col-12">
                <div class="header">
                  <h4 class="title">{{ 'Application details' | translate }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isJourney() === false && !showBackButton">
          <div class="app-status" *ngIf="applicationDetails">
            <h3 class="title">Status</h3>
            <div
              *ngIf="applicationDetails['applicationStateTrackers'].length > 0">
              <ol class="timeline">
                <li
                  *ngFor="
                    let step of applicationDetails['applicationStateTrackers'];
                    let index = index
                  "
                  class="step-item">
                  <div class="step-icon-container">
                    <div class="step-icon">
                      <img src="assets/icons/status-check.svg" alt />
                    </div>
                  </div>
                  <ng-template #otherStatus>
                    <div class="step-content">
                      <!-- Only show default state info if not a rejected state with feedback -->
                      <ng-container
                        *ngIf="
                          !(
                            step.applicationEvent === 'REJECT' &&
                            getFeedbackForTracker(step)
                          )
                        ">
                        <div class="title">
                          {{
                            getApplicationStatusToLabel(step.applicationState)
                              | translate
                          }}
                        </div>
                        <div class="item_text">
                          {{ step.stateTimestamp | date : 'short' }}
                        </div>
                      </ng-container>

                      <!-- Feedback section for rejected states -->
                      <div
                        *ngIf="
                          step.applicationEvent === 'REJECT' &&
                          getFeedbackForTracker(step)
                        "
                        class="feedback-container">
                        <div class="d-flex flex-column feedback">
                          <div class="rejection-header">
                            <i class="icon-alert-triangle text-danger me-2"></i>
                            <span class="rejected-title">{{
                              'REJECTED' | translate
                            }}</span>
                            <span class="rejected-timestamp">{{
                              step.stateTimestamp | date : 'short'
                            }}</span>
                          </div>
                          <div class="rejection-body">
                            <h3 class="comment-title">
                              {{ 'Officer comment' | translate }}
                            </h3>
                            <div
                              *ngFor="
                                let feedback of getFeedbackForTracker(step)
                              "
                              class="feedback-item">
                              <div
                                *ngIf="feedback.additionalInfo?.feedbackReason"
                                class="reason-container">
                                <span class="reason-label">{{
                                  'Reason:' | translate
                                }}</span>
                                <span class="reason-text">{{
                                  feedback.additionalInfo?.feedbackReason
                                }}</span>
                              </div>
                              <div class="comment-container">
                                <div class="comment-text">
                                  {{ feedback.comment }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-container
                    *ngIf="
                      step.applicationState.includes('PENDING_RESUBMISSION');
                      else otherStatus
                    ">
                    <div class="step-content">
                      <div class="title">
                        {{ 'Returned for my action' | translate }}
                      </div>
                      <div class="item_text">
                        {{
                          'Additional information required. Please review and update your application'
                            | translate
                        }}
                      </div>
                      <div
                        class="feedback-container"
                        *ngIf="
            applicationDetails?.['applicationFeedbacks']
              ?.feedbackResponseDetails &&
            applicationDetails?.['applicationFeedbacks']
              .feedbackResponseDetails.length
          ">
                        <irembogov-application-feedback
                          [applicationFeedBack]="
              getActiveFeedback(
                applicationDetails?.['applicationFeedbacks']
                  .feedbackResponseDetails,
                step.stateTimestamp
              )
            "></irembogov-application-feedback>
                      </div>
                    </div>
                  </ng-container>
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div *ngIf="isJourney() || !showBackButton" class="row">
          <div *ngIf="isJourney()" class="col-12">
            <irembogov-child-application-viewer
              [parentApplicationId]="application.applicationId"
              [locale]="getLocale()"
              [viewFullDetails]="applicationDetailsFetched"
              [otp]="this.otp"
              [parentApplicationType]="application.applicationType"
              (downloadReceiptbyOtp)="downloadReceiptbyOtp($event)"
              [downloadingRecieptByOtp]="downloadingReciept"
              (downloadAttachmentsbyOtp)="downloadAttachmentByOtp($event)"
              [downloadingAttachmentsByOtp]="downloadingCert"
              (requestOtpForDetails)="handleChildOtpRequest($event)">
            </irembogov-child-application-viewer>
          </div>
          <div class="col-12 d-flex">
            <a
              *ngIf="application?.applicationType !== 'JOURNEY_V3'"
              class="back-button text-decoration-none mx-auto d-flex flex-row align-items-center my-2"
              (click)="getJourneyDetails(token)">
              <i class="me-2">
                <svg
                  *ngIf="!viewFullDetails"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.51677 10.5956C2.40328 10.4159 2.34654 10.3261 2.31477 10.1875C2.29091 10.0834 2.29091 9.91922 2.31477 9.81512C2.34654 9.67654 2.40328 9.58669 2.51677 9.40699C3.45461 7.922 6.24617 4.16797 10.5003 4.16797C14.7545 4.16797 17.5461 7.922 18.4839 9.40699C18.5974 9.58669 18.6541 9.67654 18.6859 9.81512C18.7098 9.91922 18.7098 10.0834 18.6859 10.1875C18.6541 10.3261 18.5974 10.4159 18.4839 10.5956C17.5461 12.0806 14.7545 15.8346 10.5003 15.8346C6.24617 15.8346 3.45461 12.0806 2.51677 10.5956Z"
                    stroke="var(--primary-color-700)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M10.5003 12.5013C11.881 12.5013 13.0003 11.382 13.0003 10.0013C13.0003 8.62059 11.881 7.5013 10.5003 7.5013C9.11962 7.5013 8.00034 8.62059 8.00034 10.0013C8.00034 11.382 9.11962 12.5013 10.5003 12.5013Z"
                    stroke="var(--primary-color-700)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

                <svg
                  *ngIf="viewFullDetails"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.45245 4.2436C9.79113 4.19353 10.1405 4.16667 10.5003 4.16667C14.7545 4.16667 17.5461 7.9207 18.4839 9.40569C18.5974 9.58542 18.6542 9.67528 18.6859 9.81389C18.7098 9.91799 18.7098 10.0822 18.6859 10.1863C18.6541 10.3249 18.597 10.4154 18.4827 10.5963C18.2328 10.9918 17.8518 11.5476 17.3471 12.1504M6.1036 5.59586C4.30187 6.81808 3.07871 8.51615 2.51759 9.4044C2.40357 9.58489 2.34656 9.67514 2.31478 9.81373C2.29091 9.91783 2.2909 10.082 2.31476 10.1861C2.34652 10.3247 2.40328 10.4146 2.51678 10.5943C3.45462 12.0793 6.24618 15.8333 10.5003 15.8333C12.2157 15.8333 13.6932 15.223 14.9073 14.3972M3.00035 2.5L18.0003 17.5M8.73258 8.23223C8.28017 8.68464 8.00035 9.30964 8.00035 10C8.00035 11.3807 9.11963 12.5 10.5003 12.5C11.1907 12.5 11.8157 12.2202 12.2681 11.7678"
                    stroke="var(--primary-color-700)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </i>
              <span class="d-inline">{{
                viewFullDetails &&
                !(application?.applicationType === 'JOURNEY_V3')
                  ? 'Hide application summary'
                  : ('View application summary' | translate)
              }}</span>
              <i class="me-2">
                <svg
                  *ngIf="!viewFullDetails"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.5 7.5L10.5 12.5L15.5 7.5"
                    stroke="var(--primary-color-700)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

                <svg
                  *ngIf="viewFullDetails"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.5 12.5L10.5 7.5L5.5 12.5"
                    stroke="var(--primary-color-700)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </i>
            </a>
          </div>
        </div>

        <div
          *ngIf="requestingAccess"
          class="d-flex align-items-center justify-content-center text-center py-5">
          <div
            class="spinner-grow text-primary"
            style="width: 3rem; height: 3rem"
            role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div class="col-12">
          <!-- Gov3 Application Summary -->
          <irembogov-application-summary
            *ngIf="
              !isLegacyApplication && applicationSummary && viewFullDetails
            "
            [showTitle]="false"
            [application]="application"
            [applicationSummary]="applicationSummary"
            [applicationBaseUrl]="applicationBaseUrl"
            [applicationPath]="applicationPath"
            [applicationOtp]="encodedOtp">
          </irembogov-application-summary>

          <!-- Gov2 (Legacy) Application Summary -->
          <irembogov2-summary-details
            *ngIf="isLegacyApplication && gov2SummaryLoaded && viewFullDetails"
            [summary]="gov2Summary"
            [documents]="gov2Documents"
            [title]="'Application Details'"
            [hasTitle]="false"
            (attachmentClicked)="onGov2AttachmentClicked($event)">
          </irembogov2-summary-details>

          <!-- Gov2 Loading State -->
          <div
            *ngIf="isLegacyApplication && isLoadingGov2Summary"
            class="text-center py-5">
            <div
              class="spinner-grow text-primary"
              style="width: 3rem; height: 3rem"
              role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #token let-modal>
  <div class="modal-header pb-0">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'Enter the One-Time Password (OTP)' | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" [ngClass]="{ 'invalid-token': invalidToken }">
    <p class="supporting-text">
      {{
        "We've sent a code to the registered notification channels for this application."
          | translate
      }}
    </p>
    <div
      class="d-flex mb-3"
      *ngIf="
        requestAccessResponse &&
        requestAccessResponse['smsNotificationRecipient']
      ">
      <div class="flex-shrink-0">
        <span class="icon-phone modal-icon"></span>
      </div>
      <div class="flex-grow-1 ms-3 modal-icon-text">
        {{ requestAccessResponse['smsNotificationRecipient'] }}
      </div>
    </div>
    <div
      class="d-flex mb-3"
      *ngIf="
        requestAccessResponse &&
        requestAccessResponse['emailNotificationRecipient']
      ">
      <div class="flex-shrink-0">
        <span class="icon-mail-01 modal-icon"></span>
      </div>
      <div class="flex-grow-1 ms-3 modal-icon-text">
        {{ requestAccessResponse['emailNotificationRecipient'] }}
      </div>
    </div>

    <ng-otp-input
      #ngOtpInputRef
      (onInputChange)="onOtpChange($event, ngOtpInputRef)"
      [config]="{
        length: 5,
        placeholder: '0',
        inputClass: 'formControl',
        containerClass: 'custom-token-input'
      }"></ng-otp-input>
    <p *ngIf="invalidToken" class="invalidTokenMsg mt-2">
      {{
        'The code you entered is not valid. Please request a new code to continue'
          | translate
      }}.
    </p>
    <div class="resend-token mt-3">
      <p *ngIf="(countdown$ | async) !== 0">
        {{ "Didn't receive the code? Resend in" | translate }}
        <span class="count-down">{{ countdownTime }}</span>
      </p>
      <p *ngIf="(countdown$ | async) === 0">
        {{ "Didn't receive the code? " | translate }}
        <button
          type="button"
          [disabled]="resendingToken"
          (click)="isGov2Flow() ? resendGov2OTP() : resendOTP()"
          class="btn btn-link resend-btn">
          <div
            class="spinner-border spinner-border-sm"
            role="status"
            *ngIf="resendingToken">
            <span class="visually-hidden">{{ 'Loading' | translate }}...</span>
          </div>
          {{ 'Click to resend OTP' | translate }}
        </button>
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn w-100 btn-outline-dark cancel-btn"
      (click)="modal.dismiss('Cancel')">
      {{ 'Cancel' | translate }}
    </button>
    <button
      type="button"
      [disabled]="otp.length < 5"
      (click)="
        isGov2Flow() ? confirmGov2Otp(ngOtpInputRef) : confirm(ngOtpInputRef)
      "
      class="btn w-100 btn-primary">
      <div
        class="spinner-border spinner-border-sm"
        role="status"
        *ngIf="isConfirming">
        <span class="visually-hidden">{{ 'Loading' | translate }}...</span>
      </div>
      {{ 'Confirm' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #locale let-modal>
  <div class="modal-header pb-3">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'Select certificate language' | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body pb-2">
    <div
      (click)="selectLocale(item.locale)"
      [ngClass]="{ 'locale-selected': selectedCertLocale === item.locale }"
      class="locale d-flex justify-content-between align-items-center gap-2"
      *ngFor="let item of supportedLocales">
      <div class="d-flex gap-2">
        <span class="fi fi-{{ getShortLocale(item.locale) }} fis fir"></span>
        <div class="nativeName">
          {{ item.nativeName }}
        </div>
      </div>

      <label class="custom-radio-container">
        <input
          [value]="item.locale"
          [(ngModel)]="selectedCertLocale"
          type="radio"
          name="locale"
          id="locale" />
        <span class="custom-radio"></span>
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn w-100 btn-outline-dark cancel-btn"
      (click)="modal.dismiss('Cancel')">
      {{ 'Cancel' | translate }}
    </button>
    <button
      type="button"
      [disabled]="!selectedCertLocale || downloadingCert"
      (click)="downloadCertificate(selectedCertLocale)"
      class="btn w-100 btn-primary d-flex gap-2 align-items-center justify-content-center">
      <div
        class="spinner-border spinner-border-sm"
        role="status"
        *ngIf="downloadingCert">
        <span class="visually-hidden">{{ 'Loading' | translate }}...</span>
      </div>
      {{ 'Download' | translate }}
    </button>
  </div>
</ng-template>

<!-- Gov2 Attachment Preview Modal -->
<ng-template #gov2AttachmentPreviewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ gov2PreviewFileName }}</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center" style="min-height: 400px">
    <div
      *ngIf="gov2PreviewLoading"
      class="d-flex justify-content-center align-items-center"
      style="height: 400px">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <ng-container *ngIf="!gov2PreviewLoading">
      <pdf-viewer
        *ngIf="gov2PreviewIsPdf && gov2PreviewPdfData"
        [src]="gov2PreviewPdfData"
        [render-text]="true"
        [original-size]="false"
        [autoresize]="true"
        style="display: block; width: 100%; height: 80vh">
      </pdf-viewer>
      <img
        *ngIf="!gov2PreviewIsPdf && gov2PreviewImageUrl"
        [src]="gov2PreviewImageUrl"
        class="img-fluid"
        style="max-height: 80vh"
        [alt]="gov2PreviewFileName" />
    </ng-container>
  </div>
</ng-template>
